import { render, staticRenderFns } from "./PuzzleSurprise.vue?vue&type=template&id=cd2c6b5a&scoped=true&"
import script from "./PuzzleSurprise.vue?vue&type=script&lang=js&"
export * from "./PuzzleSurprise.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleSurprise.vue?vue&type=style&index=0&id=cd2c6b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2c6b5a",
  null
  
)

export default component.exports